"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _jsxRuntime = require("react/jsx-runtime");
const Columns = _ref => {
  let {
    children,
    col
  } = _ref;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    className: `grid gap-y-4 lg:gap-y-12  gap-x-4  grid-cols-1 sm:grid-cols-2 ${col === 3 ? "lg:grid-cols-3 lg:gap-x-12" : col === 4 ? "lg:grid-cols-4 gap-x-4" : col === 6 ? "lg:grid-cols-6 grid-cols-2 gap-x-4" : "lg:grid-cols-3 lg:gap-x-12"}`,
    children: children
  });
};
var _default = Columns;
exports.default = _default;